export default __webpack_public_path__ + "static/media/app-bar-save.e07c8f7d.svg";